import { render, staticRenderFns } from "./ExplainButton.vue?vue&type=template&id=1b7a8b6e&scoped=true&"
import script from "./ExplainButton.vue?vue&type=script&lang=ts&"
export * from "./ExplainButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7a8b6e",
  null
  
)

export default component.exports